import React from 'react';
import { useNavigate } from 'react-router-dom';
import { AlertTriangle, Clock, ArrowRight } from 'lucide-react';
import { Button } from './ui/button';

interface ShiftChangeWarningModalProps {
  isOpen: boolean;
  currentShift: string;
  actualShift: string;
  onClose: () => void;
}

export const ShiftChangeWarningModal: React.FC<ShiftChangeWarningModalProps> = ({
  isOpen,
  currentShift,
  actualShift,
  onClose,
}) => {
  const navigate = useNavigate();

  if (!isOpen) return null;

  const handleGoToCashRegister = () => {
    onClose();
    navigate('/cash-register');
  };

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4 animate-in fade-in zoom-in duration-200">
        <div className="p-6">
          {/* Header con icono */}
          <div className="flex items-center gap-4 mb-4">
            <div className="flex-shrink-0 w-14 h-14 bg-amber-100 rounded-full flex items-center justify-center">
              <AlertTriangle className="w-7 h-7 text-amber-600" />
            </div>
            <div>
              <h3 className="text-xl font-bold text-gray-900">
                Cambio de Turno
              </h3>
              <p className="text-sm text-gray-500 mt-0.5">
                Es hora de cerrar caja
              </p>
            </div>
          </div>

          {/* Mensaje */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <div className="flex items-center gap-2 mb-3">
              <Clock className="w-5 h-5 text-amber-600" />
              <span className="font-medium text-amber-800">
                El turno ha cambiado
              </span>
            </div>
            <p className="text-amber-700 text-sm mb-3">
              La caja está abierta en el turno de <span className="font-bold">{currentShift}</span>,
              pero según el horario del local ya deberías estar en el turno de <span className="font-bold">{actualShift}</span>.
            </p>
            <p className="text-amber-700 text-sm">
              Por favor, cierra la caja del turno actual para poder iniciar el nuevo turno.
            </p>
          </div>

          {/* Resumen visual */}
          <div className="flex items-center justify-center gap-4 mb-6">
            <div className="text-center">
              <div className="text-xs text-gray-500 mb-1">Turno Actual</div>
              <div className="bg-gray-100 px-4 py-2 rounded-lg">
                <span className="font-bold text-gray-700">{currentShift}</span>
              </div>
            </div>
            <ArrowRight className="w-5 h-5 text-gray-400" />
            <div className="text-center">
              <div className="text-xs text-gray-500 mb-1">Turno Esperado</div>
              <div className="bg-blue-100 px-4 py-2 rounded-lg">
                <span className="font-bold text-blue-700">{actualShift}</span>
              </div>
            </div>
          </div>

          {/* Botones */}
          <div className="flex gap-3">
            <Button
              onClick={onClose}
              variant="outline"
              className="flex-1"
            >
              Continuar así
            </Button>
            <Button
              onClick={handleGoToCashRegister}
              className="flex-1 bg-amber-500 hover:bg-amber-600 text-white"
            >
              Ir a Cerrar Caja
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};
